import React, { useCallback, useEffect, useState } from 'react'
import SwiperCore, { Navigation } from 'swiper'
import classnames from 'classnames'

import { useAuthState } from 'hooks'
import useReferralInvite from 'hooks/useReferralInvite'
import useAppBanner from 'hooks/use-app-banner'
import { constants } from 'helpers'

import { AuthModal, Spinner } from 'components'
import Waitlist from './Waitlist'
import AcceptedMember from './AcceptedMember'

const {
  AUTH_STATUS: { LOGGING_IN },
  WAITLIST_STATUS,
} = constants

SwiperCore.use([Navigation])

const Discover = ({ history, location }) => {
  const { status, user } = useAuthState()
  const [showAuthModal, setShowAuthModal] = useState(false)
  const { AppBanner } = useAppBanner()
  useReferralInvite()

  useEffect(() => {
    if (!user && status !== LOGGING_IN) {
      setShowAuthModal(true)
    }
  }, [user, status])

  const handleAuthComplete = useCallback(() => {
    setShowAuthModal(false)
  }, [])

  return (
    <div
      className={classnames('flex flex-col justify-between', {
        'min-h-screen': !user,
      })}
    >
      {!user || status === LOGGING_IN ? (
        <div className="flex-col justify-between h-screen-less-navbar-m md:h-screen-less-navbar flex">
          <div className="w-full flex justify-center items-center text-white flex-grow h-72 md:h-auto">
            <Spinner />
          </div>
        </div>
      ) : (
        <>
          {user?.waitlistStatus === WAITLIST_STATUS.YES || !user?.waitlist ? (
            <AcceptedMember user={user} />
          ) : (
            <>
              <Waitlist user={user} location={location} history={history} />
            </>
          )}
        </>
      )}
      <AuthModal show={showAuthModal} onComplete={handleAuthComplete} />
      <AppBanner />
    </div>
  )
}

export default Discover
